import React from 'react'

const ErrorPage = () => {
  return (
    <div>
      <p style={{ textAlign: 'center' }}>Das Laden der Daten dauert länger oder es wird eine Webseite nicht gefunden (HTTP Error 404). Kontakt: ost.ch/ifs.</p>
    </div>
  )
}

export default ErrorPage
